<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12.71,5.289999940395355C12.71,5.289999940395355,8.71,1.2899999403953553,8.71,1.2899999403953553C8.530000000000001,1.1099999403953553,8.280000000000001,0.9999999403953552,8,0.9999999403953552C7.72,0.9999999403953552,7.47,1.1099999403953553,7.29,1.2899999403953553C7.29,1.2899999403953553,3.29,5.289999940395355,3.29,5.289999940395355C3.11,5.469999940395355,3,5.719999940395355,3,5.999999940395355C3,6.549999940395355,3.45,6.999999940395355,4,6.999999940395355C4.28,6.999999940395355,4.53,6.889999940395355,4.71,6.709999940395355C4.71,6.709999940395355,8,3.4099999403953554,8,3.4099999403953554C8,3.4099999403953554,11.29,6.699999940395355,11.29,6.699999940395355C11.47,6.889999940395355,11.72,6.999999940395355,12,6.999999940395355C12.55,6.999999940395355,13,6.549999940395355,13,5.999999940395355C13,5.719999940395355,12.89,5.469999940395355,12.71,5.289999940395355C12.71,5.289999940395355,12.71,5.289999940395355,12.71,5.289999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyControl',
} as DefineComponent
</script>
